'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('AdminSystemOwnerReviewControllers')

.factory('adminSystemOwnerReviewService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/ID/SystemOwner/Review/API/Admin';

    // HttpGet
    service.getAllSystemOwnerReviewProcesses = function () {
        return $http.get(baseUrl + '/Process')
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getPrimarySystemOwnersAndChanges = function () {
        return $http.get(baseUrl + '/PrimarySystemOwnersAndChanges')
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;

}]);
